// import React, { StrictMode } from 'react';
// import './AboutUs.css';


// const AboutUs = () => {
//   return (
//     <div className="about-page">
//       <div className="about-intro">

//         <div className="about-intro__text">
//           <h2>Vetrieq - The Victory</h2>

//           <p>
//             <strong>Vetrieq - The Victory -</strong> is a name with purpose,
//             rooted in vision, hard work, and commitment.
//           </p>

//            <div className="about-intro__image-container">
//           <img
//             src="https://ik.imagekit.io/bapyu1ycr/personal%20images/Our%20Shop.jpeg"
//             alt="Our First Shop"
//             className="about-intro__image"
//           />
//         </div>

//           <p>
//             At <strong>Vetrieq</strong>, we proudly carry forward a{" "}
//             <strong>45-year legacy</strong> built on trust, quality, and
//             service excellence. What began decades ago from a humble family-run
//             setup in a small local shop has now evolved into a dynamic export
//             brand serving global markets with a wide range of high-quality
//             products.
//           </p>

//           <p>
//             The image above represents where our journey truly started — a
//             modest beginning built with dedication, perseverance, and strong
//             family values. From these roots, we steadily expanded our vision
//             beyond local trade into international exports while staying true to
//             the principles that shaped us from day one.
//           </p>

//           <p>
//             Our team brings together deep industry experience and modern export
//             expertise, ensuring that every product we deliver meets
//             international standards. With a{" "}
//             <strong>strong customer-first approach</strong>, we focus on
//             understanding market needs, maintaining strict quality control, and
//             providing reliable, timely shipments to our partners worldwide.
//           </p>

//           <p>
//             Established with the vision to take our diverse product capabilities
//             to the global stage, Vetrieq Exports is committed to
//             sustainability, efficiency, and consistent product excellence. Over
//             the years, we have grown into a trusted export partner known for
//             transparent practices, dependable service, and long-term business
//             relationships.
//           </p>

//           <p>
//             Our core values—Integrity, Quality, and Innovation—shape every
//             aspect of our operations. We believe in continuous improvement,
//             strong collaboration with clients and suppliers, and leveraging
//             modern technologies to stay ahead in a constantly evolving global
//             marketplace.
//           </p>

//           <p>
//             Join us as we continue expanding our global footprint—
//             <strong>
//               {" "}
//               delivering trusted, high-quality Indian products from Vetrieq to
//               the world.
//             </strong>
//           </p>
//         </div>
//       </div>

//       <section className="about-mission">
//         <h2>Our Mission</h2>
//         <p>
//           Our mission is to deliver high-quality products to global markets with
//           reliability, transparency, and excellence. We strive to meet today’s
//           international trade demands while proactively preparing for future
//           market needs. Through strong partnerships, disciplined processes, and
//           a commitment to continuous improvement, Vetrieq aims to drive growth,
//           ensure efficiency, and provide unmatched value to our customers
//           worldwide.
//         </p>
//       </section>

//       <section className="about-vision">
//         <h2>Our Vision</h2>
//         <p>
//           We envision a future where Vetrieq becomes a globally trusted name
//           for quality, reliability, and ethical trade. Our vision is to expand
//           our presence across international markets by delivering diverse,
//           world-class products that reflect our legacy and commitment. We are
//           dedicated to pushing boundaries, adopting global best practices, and
//           setting new standards of excellence in the export industry—building a
//           brand that stands for success, integrity, and unmatched quality.
//         </p>
//       </section>
//     </div>
//   );
// };

// export default AboutUs;


// AboutUs.jsx

import React from "react";
import "./AboutUs.css";

const AboutUs = () => {
  return (
    <div className="about-page">

      {/* HERO SECTION */}
      <section className="about-hero">

        <div className="about-hero-overlay"></div>

        <div className="about-hero-content">

          <h1>About Vetrieq</h1>

          <p>
            Carrying forward a 45+ year legacy of trust,
            quality, and global excellence.
          </p>

        </div>

      </section>

      {/* INTRO SECTION */}
      <section className="about-intro">

        <div className="about-intro-image">

          <img
            src="https://ik.imagekit.io/bapyu1ycr/personal%20images/Our%20Shop.jpeg"
            alt="Our First Shop"
          />

        </div>

        <div className="about-intro-content">

          <div className="section-badge">
            Vetrieq - The Victory
          </div>

          <h2>
            A Journey Built on Trust & Excellence
          </h2>

          <p>
            <strong>Vetrieq</strong> proudly carries forward a
            <strong> 45-year legacy</strong> rooted in trust,
            dedication, quality, and service excellence.
            What began as a humble family-run local shop has now
            evolved into a dynamic export company serving global markets.
          </p>

          <p>
            The image above represents where our story truly began —
            a small shop built with perseverance, honesty, and strong
            family values. These foundations continue to guide us as we
            expand into international trade and exports.
          </p>

          <p>
            Today, our team combines deep industry experience with modern
            export expertise, ensuring every shipment meets international
            quality standards and customer expectations worldwide.
          </p>

          <p>
            We are committed to transparency, reliability, sustainability,
            and long-term partnerships. Through continuous improvement and
            innovation, we aim to bring the finest Indian products to the
            global stage.
          </p>

        </div>

      </section>

      {/* STATS SECTION */}
      <section className="about-stats">

        <div className="stat-box">
          <h3>45+</h3>
          <p>Years Legacy</p>
        </div>

        <div className="stat-box">
          <h3>100+</h3>
          <p>Export Products</p>
        </div>

        <div className="stat-box">
          <h3>Global</h3>
          <p>International Reach</p>
        </div>

        <div className="stat-box">
          <h3>100%</h3>
          <p>Commitment to Quality</p>
        </div>

      </section>

      {/* MISSION & VISION */}
      <section className="mission-vision-section">

        {/* MISSION */}
        <div className="mission-card">

          <div className="mission-image">
            <img
              src="https://images.unsplash.com/photo-1520607162513-77705c0f0d4a"
              alt="Mission"
            />
          </div>

          <div className="mission-content">

            <h2>Our Mission</h2>

            <p>
              Our mission is to deliver premium-quality products to
              international markets with reliability, transparency,
              and excellence.
            </p>

            <p>
              Through disciplined processes, ethical business practices,
              and strong customer relationships, we strive to exceed
              global expectations while creating long-term value for
              our clients worldwide.
            </p>

          </div>

        </div>

        {/* VISION */}
        <div className="vision-card">

          <div className="vision-content">

            <h2>Our Vision</h2>

            <p>
              We envision Vetrieq becoming a globally trusted export
              brand known for quality, integrity, and innovation.
            </p>

            <p>
              Our goal is to expand our international presence while
              setting new standards of excellence in the export industry,
              delivering products that reflect the richness and quality
              of India to the world.
            </p>

          </div>

          <div className="vision-image">

            <img
              src="https://images.unsplash.com/photo-1578575437130-527eed3abbec"
              alt="Vision"
            />

          </div>

        </div>

      </section>

      {/* VALUES SECTION */}
      <section className="core-values">

        <h2>Our Core Values</h2>

        <div className="values-grid">

          <div className="value-card">
            <span>🤝</span>
            <h3>Integrity</h3>
            <p>
              Building trust through ethical and transparent business practices.
            </p>
          </div>

          <div className="value-card">
            <span>⭐</span>
            <h3>Quality</h3>
            <p>
              Delivering export-grade products that meet global standards.
            </p>
          </div>

          <div className="value-card">
            <span>🚀</span>
            <h3>Innovation</h3>
            <p>
              Continuously improving through technology and modern solutions.
            </p>
          </div>

        </div>

      </section>

    </div>
  );
};

export default AboutUs;